/**
 * LovableRoute: /resources/lovable
 *
 * The page itself is EcosystemPath; the steps are data in lib/ecosystemData,
 * the same as every other tool route.
 */

import EcosystemPath from "@/components/EcosystemPath";
import NotFound from "@/pages/NotFound";
import { toolPath } from "@/lib/ecosystemData";

export default function LovableRoute() {
  const path = toolPath("lovable");
  if (!path) return <NotFound />;
  return <EcosystemPath path={path} />;
}
